import { TabPanel, TabPanels, Tabs, VStack } from "@chakra-ui/react";
import { useLocalStorageState } from "../../hooks/localStorage";
import "../../styles/printing.css";
import { GenericPrintGraphsView } from "../GenericPrintGraphsView/GenericPrintGraphsView";
import { PrintControls } from "../PrintControls/PrintControls";
import { WellLevelsPrintGraphsView } from "../WellLevelsPrintGraphsView/WellLevelsPrintGraphsView";

export function PrintGraphsPage() {
  const [dashBoardSettings] = useLocalStorageState({
    key: "dashboard",
    value: { tabIndex: 0 },
  });

  return (
    <VStack alignItems={"start"} padding={4}>
      <PrintControls />
      <Tabs index={dashBoardSettings.tabIndex}>
        <TabPanels>
          <TabPanel>
            <div>Something went wrong</div>
          </TabPanel>
          <TabPanel>
            <div>Something went wrong</div>
          </TabPanel>
          <TabPanel>
            <GenericPrintGraphsView project="surfaceWater" />
          </TabPanel>
          <TabPanel>
            <GenericPrintGraphsView project="groundWater" />
          </TabPanel>
          <TabPanel>
            <WellLevelsPrintGraphsView />
          </TabPanel>
          <TabPanel>
            <GenericPrintGraphsView project="drinkingWater" />
          </TabPanel>
          <TabPanel>
            <div>Something went wrong</div>
          </TabPanel>
        </TabPanels>
      </Tabs>
    </VStack>
  );
}
